<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="scroll-box">
                <v-container class="modal-container">
                    <v-row>
                        <v-col>
                            <h1>Importação</h1>
                            <v-row v-if="loading">
                                <v-col class="justify-center align-center">
                                    <v-progress-circular :size="35"
                                                        color="primary"
                                                        indeterminate />
                                </v-col>
                            </v-row>
                            <v-row class="command-col">
                                <v-col>
                                    <button type="button"
                                            class="btn-update"
                                            @click="importItem($event)"
                                            :disabled="loading"
                                            title="Adicionar os investimentos desta importação para o Kristal">
                                        Adicionar ao Kristal
                                    </button>
                                </v-col>
                                <v-col>
                                    <button type="button"
                                            class="btn-remote"
                                            @click="updateItem($event)"
                                            :disabled="loading"
                                            title="Atualizar os dados importados com informações mais recentes">
                                        Solicitar atualização
                                    </button>
                                </v-col>
                                <v-col>
                                    <button type="button"
                                            class="btn-reload"
                                            @click="$emit('reload')"
                                            :disabled="loading"
                                            title="Recarregar os dados armazenados na Kristal">
                                        Recarregar
                                    </button>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col>Código: {{ source.code }}</v-col>
                                <v-col><span class="id-label"></span> {{ source.id }}</v-col>
                            </v-row>
                            <v-row>
                                <v-col><span class="user-label"></span> {{ source.userId }}</v-col>
                                <v-col>Status: {{ source.status }}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>Execução: {{ source.executionStatus }}</v-col>
                                <v-col>Mensagem da execução: {{ source.message }}</v-col>
                            </v-row>
                            <v-row>
                                <v-col>Importação: {{ formatDate(source.createdAt) }}</v-col>
                                <v-col>Atualizado: {{ formatDate(source.updatedAt) }}</v-col>
                            </v-row>
                            <v-row class="bottom-row">
                                <v-col>Registro: {{ formatDate(source.lastUpdatedAt) }}</v-col>
                                <v-col v-if="source.connector">
                                    Via: {{ source.connector.id }} - {{ source.connector.name }} ({{ source.connector.type }})
                                    <img :src="source.connector.imageUrl" alt="Conector" class="thumb" width="20" height="20" />
                                </v-col>
                                <v-col v-else>
                                    De: Não identificado
                                </v-col>
                            </v-row>
                            <v-row class="data-table"
                                   v-if="source.investments && source.investments.length">
                                <v-col>
                                    <h1>Investimentos</h1>
                                    <v-row>
                                        <ul>
                                            <li>Clique nos códigos dos investimentos para editá-los;</li>
                                            <li class="desktop-item">Passe o mouse sobre o status de importação para ver mensagem e data (se existir).</li>
                                        </ul>
                                    </v-row>
                                    <v-row class="data-header">
                                        <v-col>Nome</v-col>
                                        <v-col>Código</v-col>
                                        <v-col>Importação</v-col>
                                        <v-col>Data</v-col>
                                        <v-col>Vencimento</v-col>
                                        <v-col>Marcado?</v-col>
                                    </v-row>
                                    <v-row class="data-body"
                                           v-for="investment in source.investments"
                                           :key="investment.investmentId"
                                           @click="viewInvestment(investment)">
                                        <v-col>
                                            <span class="short-label">Nome:</span>
                                            {{ investment.name }}
                                        </v-col>
                                        <v-col class="code-editable">
                                            <div @click="editCode($event, investment)"
                                                    title="Clique para editar o código">
                                                <span class="short-label">Código:</span> {{ investment.code }}
                                            </div>
                                        </v-col>
                                        <v-col><span class="short-label">Importação:</span>
                                            <span :title="(investment.message_imp && investment.message_imp.trim() || 'Sem mensagem') + ' - ' + formatDateAbbr(investment.date_imp)">
                                                {{ investment.status_imp }}
                                            </span>
                                        </v-col>
                                        <v-col><span class="short-label">Data:</span>{{ formatDateAbbr(investment.date) }}</v-col>
                                        <v-col><span class="short-label">Vencimento:</span>{{ formatDateAbbr(investment.dueDate) }}</v-col>
                                        <v-col><span class="short-label">Marcado?:</span>{{ isSelected(investment) ? '☑️' : ' ' }}</v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row class="remove-col">
                                <v-col>
                                    <button type="button"
                                            class="btn-cancel"
                                            @click="cancelItem($event)"
                                            :disabled="loading"
                                            title="Remover o item de importação. Não será mais possível atualizar">
                                        Remover
                                    </button>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-container>
            </div>
        </div>

        <v-btn icon
            class="close-btn"
            :disabled="loading"
            @click="$emit('close')">
            <img src="@/assets/icons/close.svg"
                alt="dashboard"
                class="icon" />
        </v-btn>

        <InvestmentDetails v-if="displaying"
                           @close="displaying = false"
                           :source="target" />
    </div>
</template>

<style scoped>
.close-btn {
  position: fixed;
  top: 6%;
  right: 6%;
}
.modal-mask {
  position: fixed;
  z-index: 20;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-container {
  min-width: 100% !important;
  min-height: 100% !important;
  margin: 0px auto;
  padding: 30px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}
.modal-wrapper > .scroll-box {
  max-width: 90% !important;
  width: 90% !important;
  max-height: 90% !important;
  height: 90% !important;
  margin: auto;
  padding: 0;
  overflow-x: hidden;
  overflow-y: scroll;
  display: block;
}
.modal-container .row .col .row .col {
    height: 1.8rem;
}
.modal-container .row .col .row.command-col .col {
    height: 4.5rem;
    min-height: 4.5rem;
    border-bottom: 2px solid rgba(128, 0, 0, .75);
    align-content: center;
    text-align: center;
}
.modal-container .row .col .row.data-table {
    height: unset;
    min-height: fit-content;
    font-size: 0.8rem;
    text-align: center;
    margin: 0.5rem;
}
.modal-container .row .col .row.data-table ul {
    text-align: justify;
}
.modal-container .row .col .row.bottom-row {
    border-bottom: 2px solid rgba(128, 0, 0, .75);
    padding-bottom: 1.5rem;
}
.modal-container .row .col .row.data-table h1 {
    font-weight: bold;
    font-size: 1.5rem;
    margin-bottom: 1rem;
}
.modal-container .row .col .row.data-table .col {
    height: unset;
    min-height: fit-content;
    padding: 0.25rem;
    cursor: pointer;
}
.modal-container .row .col button {
    background-color: #888888;
    color: white;
    border-radius: 10px;
    padding: 0 0.5rem;
    margin: 0;
    cursor: pointer;
    width: 80%;
}
.data-header .col {
    background-color: black;
    color: white;
    font-weight: bold;
}
.data-body:nth-child(odd) {
    background-color: #DDDDDD;
}
span.id-label:before {
    content: "Identificador:";
}
span.user-label:before {
    content: "Usuário:";
}
.code-editable > div {
    background-color: #AAAAAA;
}
.row.data-table .short-label {
    display: none;
}
.row.command-col .col button.btn-update {
    background-color: rgba(0, 64, 0, 0.5);
}
.row.command-col .col button.btn-remote {
    background-color: rgba(0, 0, 64, 0.5);
}
.row .col .row.remove-col .col {
    height: 4.5rem;
    min-height: 4.5rem;
    align-content: center;
    text-align: center;
}
.row .col .row.remove-col button.btn-cancel {
    background-color: rgba(128, 0, 0, 1);
    color: white;
    font-weight: bold;
    width: 20%;
}
.row.command-col .col button.btn-reload {
    color: rgba(64, 64, 64, 0.75);
    background-color: white;
    border: 1px solid rgba(128, 128, 128, 0.5);
    font-weight: bold;
}
@media screen and (max-width: 1024px) {
    .close-btn {
        top: 1%;
        right: 6%;
    }
    .modal-container .row {
        flex-direction: column;
    }
    .modal-container .row .col .row .col {
        font-size: 0.75rem;
        height: unset;
        min-height: 1.8rem;
    }
    .modal-container .row .col button {
        padding: 0.35rem;
    }
    .modal-wrapper > .scroll-box {
        max-height: unset;
        height: unset;
        min-width: 100% !important;
        max-width: unset;
        width: unset;
        min-height: fit-content;
    }
    .modal-wrapper {
        display: block;
        height: 100%;
        width: 100%;
        overflow: scroll;
    }
    span.id-label:before {
        content: "Id:";
    }
    span.user-label:before {
        content: "Usuário:";
    }
    .modal-container .row .col .row.data-table {
        text-align: justify;
    }
    .modal-container .row .col .row.data-table .data-header {
        display: none;
    }
    .row.data-table .short-label {
        display: inline;
    }
    .modal-container .row .col .row.command-col .col {
        height: 3rem;
        min-height: 3rem;
    }
    .data-body {
        border-radius: 10px;
        background-color: #DDDDDD;
        margin: 0.75rem 0;
    }
    .desktop-item {
        display: none;
    }
}
</style>

<script lang="js">
import ApiService from '../../../../../services/ApiService';
import EventBus from '../../../../Bus/bus';
import currencyHelper from '../../../../../Utils/CurrencyHelper';
import percentageHelper from '../../../../../Utils/PercentageHelper';
import InvestmentDetails from './InvestmentDetails.vue';

export default          {
    props               : {
        source          : { type: Object }
    },
    data                () {
        return {
            currencyHelper,
            percentageHelper,
            apiService  : undefined,
            loading     : false,
            displaying  : false,
            target      : undefined
        };
    },
    components          : { InvestmentDetails },
    methods             : {
        formatDate      (value) {
            if (!value) { return '' }
            var dt = new Date(value);
            return `${dt.toLocaleDateString()} ${dt.toLocaleTimeString()}`;
        },
        formatDateAbbr  (value) {
            if (!value) { return '' }
            var dt = new Date(value);
            return dt.toLocaleDateString();
        },
        viewInvestment  (inv) {
            if (this.loading || !inv) { return; }
            this.displaying = true;
            this.target     = inv;
        },
        importItem      (e) {
            e.cancelBubble = true;
            e.preventDefault();
            if (this.loading || !this.source) { return; }
            this.loading = true;
            return this.apiService.importPluggyItem(this.source.id)
                .then((data) => {
                    this.loading = false;
                    if (!data.success) {
                        this.$toast.error(data.message);
                        return;
                    }
                    this.$toast.info(data.message);
                    return this.readInvestments();
                });
        },
        updateItem      (e) {
            e.cancelBubble = true;
            e.preventDefault();
            if (this.loading || !this.source) { return; }
            const userId = this.$store.getters.$tokenUserSelected;
            if (!userId) {
                this.$toast.error('Usuário não identificado.');
                return;
            }
            this.loading = true;
            return this.apiService.updatePluggyItem(this.source.id, userId)
                .then((data) => {
                    this.loading = false;
                    if (!data.success) {
                        this.$toast.error(data.message);
                        return;
                    }
                    this.$toast.info('Solicitação efetuada, aguarde a atualização dos dados...');
                });
        },
        cancelItem      (e) {
            e.cancelBubble = true;
            e.preventDefault();
            if (this.loading || !this.source) { return; }
            const message = "Essa ação irá REMOVER essa importação. " +
                            "Não será mais possível utilizá-la. " +
                            "Se você já fez a adição dos dados ao Kristal " +
                            "eles NÂO serão removidos em conunto. Confirmar a operação?";
            if (!confirm(message)) { return; }
            const userId = this.$store.getters.$tokenUserSelected;
            if (!userId) {
                this.$toast.error('Usuário não identificado.');
                return;
            }
            this.loading = true;
            return this.apiService.deletePluggyItem(this.source.id, userId)
                .then((data) => {
                    this.loading = false;
                    if (!data.success) {
                        this.$toast.error(data.message);
                        return;
                    }
                    this.$toast.info('Solicitação efetuada, aguarde a atualização dos dados...');
                    setTimeout(() => this.$emit('reload'), 3000);
                });
        },
        editCode        (e, investment) {
            e.cancelBubble = true;
            e.preventDefault();
            const call = {
                width  : 400,
                height : 300,
                view   : 'EditarCodigoInvestimento'
            };
            EventBus.$emit('openFloatModal', call, investment);
        },
        isSelected      (investment) {
            if (!investment) { return false; }
            return investment.status_imp === 'Marcado para importação.' ||
                investment.transactions.some((t) => t.import);
        }
    },
    created             () {
        this.apiService = new ApiService();
    },
    mounted             () {

    },
    beforeDestroy       () {

    }
}
</script>